var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleUncheckedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "797F7B14-A3D8-4D06-B7DD-35F9D15765F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 25,
    height: 25,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-454.000000, -740.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-11",
    transform: "translate(454.000000, 740.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.2116041,7.79825559 C19.8270762,7.41372772 19.2059158,7.41372772 18.8213879,7.79825559 L14,12.6097838 L9.17861206,7.7883959 C8.79408419,7.40386803 8.17292378,7.40386803 7.7883959,7.7883959 C7.40386803,8.17292378 7.40386803,8.79408419 7.7883959,9.17861206 L12.6097838,14 L7.7883959,18.8213879 C7.40386803,19.2059158 7.40386803,19.8270762 7.7883959,20.2116041 C8.17292378,20.596132 8.79408419,20.596132 9.17861206,20.2116041 L14,15.3902162 L18.8213879,20.2116041 C19.2059158,20.596132 19.8270762,20.596132 20.2116041,20.2116041 C20.596132,19.8270762 20.596132,19.2059158 20.2116041,18.8213879 L15.3902162,14 L20.2116041,9.17861206 C20.5862723,8.80394388 20.5862723,8.17292378 20.2116041,7.79825559 Z",
    id: "Icon-Color",
    fill: "#50566E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleUncheckedIcon);
export default __webpack_public_path__ + "static/media/toggleUncheckedIcon.737fbc9ed8ccadcc0c9eedf9d4014f48.svg";
export { ForwardRef as ReactComponent };